module.exports = __webpack_public_path__ + "img/sec3_button.98056912.jpg";